module.exports = __webpack_public_path__ + "img/madhavi.a69a19f9.jpeg";